import { dateSorted } from '@standardnotes/utils';
import { serverKeyParamsAreSafe } from './Utils';
import { DecryptItemsKeyByPromptingUser, } from '@standardnotes/services';
import { ContentType } from '@standardnotes/domain-core';
export class KeyRecoveryOperation {
    constructor(queueItem, itemManager, encryptionService, challengeService, clientParams, serverParams) {
        this.queueItem = queueItem;
        this.itemManager = itemManager;
        this.encryptionService = encryptionService;
        this.challengeService = challengeService;
        this.clientParams = clientParams;
        this.serverParams = serverParams;
    }
    async run() {
        let replaceLocalRootKeyWithResult = false;
        const queueItemKeyParamsAreBetterOrEqualToClients = this.serverParams &&
            this.clientParams &&
            !this.clientParams.compare(this.serverParams) &&
            this.queueItem.keyParams.compare(this.serverParams) &&
            serverKeyParamsAreSafe(this.serverParams, this.clientParams);
        if (queueItemKeyParamsAreBetterOrEqualToClients) {
            const latestDecryptedItemsKey = dateSorted(this.itemManager.getItems(ContentType.TYPES.ItemsKey), 'created_at', false)[0];
            if (!latestDecryptedItemsKey) {
                replaceLocalRootKeyWithResult = true;
            }
            else {
                replaceLocalRootKeyWithResult = this.queueItem.encryptedKey.created_at > latestDecryptedItemsKey.created_at;
            }
        }
        const decryptionResult = await DecryptItemsKeyByPromptingUser(this.queueItem.encryptedKey, this.encryptionService, this.challengeService, this.queueItem.keyParams);
        if (decryptionResult === 'aborted') {
            return { aborted: true };
        }
        if (decryptionResult === 'failed') {
            return { aborted: false };
        }
        return {
            rootKey: decryptionResult.rootKey,
            replaceLocalRootKeyWithResult,
            decryptedItemsKey: decryptionResult.decryptedKey,
        };
    }
}
